import React from 'react'
import { tv } from 'tailwind-variants'

const progressBarStyles = tv({
  slots: {
    track: 'w-full bg-surface-muted rounded h-2.5',
    fill: 'h-2.5 rounded transition-all'
  },
  variants: {
    colour: {
      green: { fill: 'bg-green' },
      orange: { fill: 'bg-orange' },
      red: { fill: 'bg-red' }
    }
  },
  defaultVariants: {
    colour: 'green'
  }
})

interface ProgressBarProps {
  percentage: number
  classNames?: {
    track?: string
    fill?: string
  }
  autoColour?: boolean
}

const ProgressBar: React.FC<ProgressBarProps> = ({ percentage, classNames, autoColour = false }) => {
  const clamped = Math.min(Math.max(percentage, 0), 100)
  const colour = autoColour ? (clamped > 90 ? 'red' : clamped > 75 ? 'orange' : 'green') : undefined
  const { track, fill } = progressBarStyles({ colour })

  return (
    <div className={track({ class: classNames?.track })} data-slot="track">
      <div className={fill({ class: classNames?.fill })} style={{ width: `${clamped}%` }} data-slot="fill" />
    </div>
  )
}

export default ProgressBar
